import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

import { Pagination } from './pagination.types'
import { Error } from './error.types'

interface Symptom {
  id: number
  description: string
}

interface ListSymptomsData {
  symptoms: Symptom[]
  pagination: Pagination
}

interface ListSymptomsResponse {
  symptoms: Symptom[]
  pagination: Pagination
}

export const listSymptoms = (query?: string, page?: number): Promise<ListSymptomsResponse> => {
  const endpoint = apiEndpoints.MEDICAL_RECORDS_SYMPTOMS

  const params = {
    per_page: 10,
    ...(query && { query }),
    ...(page && { page }),
  }

  return new Promise<ListSymptomsResponse> ((resolve, reject) => {
    axios.get<ListSymptomsData>(endpoint, { params })
      .then(response => {
        const symptoms = response.data.symptoms

        const pagination = response.data.pagination

        resolve({
          symptoms,
          pagination,
        })
      })
      .catch((error: Error) => 
        reject(error?.response?.status)
      )
  })
}